import { PaymentApiClientURLs, PaymentApiClientInterface } from '@/models/api-client/payment'
import { DownPaymentInterface, RepaymentScheduleInterface } from '@/models/composables'
import { RuntimeConfigsInterface } from '@/models/configs/configs.interface'
import { IHttpRequestParams } from '@/models/http-client'
import { HttpClient } from '@/utils/http-client/HttpClient'

export class PaymentApiClient implements PaymentApiClientInterface {
  private readonly urls!: PaymentApiClientURLs

  constructor(urls: PaymentApiClientURLs) {
    this.urls = urls
  }

  getRepaymentSchedule(queryParams: RepaymentScheduleInterface, runtimeConfigs: RuntimeConfigsInterface): Promise<any> {
    return new Promise<RepaymentScheduleInterface>((resolve) => {
      const url = this.urls.repaymentScheduleURL
      const parameters: IHttpRequestParams = {
        path: url,
        queryParams: queryParams
      }
      const res: Promise<any> = HttpClient.get(parameters, runtimeConfigs)
      resolve(res)
    })
  }

  getCardDetails(runtimeConfigs: RuntimeConfigsInterface): Promise<any> {
    console.log(runtimeConfigs)
    return new Promise<RepaymentScheduleInterface>((resolve) => {
      const url = this.urls.getCardDetailsURL
      const parameters: IHttpRequestParams = {
        path: url
      }
      const res: Promise<any> = HttpClient.get(parameters, runtimeConfigs)
      resolve(res)
    })
  }

  makeDownPayment(payload: DownPaymentInterface, runtimeConfigs: RuntimeConfigsInterface): Promise<any> {
    return new Promise<RepaymentScheduleInterface>((resolve) => {
      const url = this.urls.downPaymentURL
      const parameters: IHttpRequestParams = {
        path: url,
        payload: payload
      }
      const res: Promise<any> = HttpClient.post(parameters, runtimeConfigs)
      resolve(res)
    })
  }
}
